"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tree2Element = void 0;
const react_1 = __importDefault(require("react"));
const tree2Element = (tree) => tree?.map((node, i) => react_1.default.createElement(node.tag, { key: i, ...node.attr }, (0, exports.tree2Element)(node.child)));
exports.tree2Element = tree2Element;
